/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import {declareLinkedEntity} from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "scenarioFlowDefs",
    graphQL: "ScenarioFlowDef",
    storageType: 'central',
    name: "Scenario Flow Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    defaultTitle: (data) => {
        return data['name'];
    },
    parentRelation: "scenarioFlowDefs",
    isPublic: true,
    defaultOrder: ['name'],
    fields: (types) => { return {
        id: {
            name: "Scenario Flow Def ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
        },
        name: {
            name: "Name",
            description: "Name of Flow Definition",
            trim: true,
            type: "string",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        scenarioDef: {
            name: "Scenario Definition",
            to: () => types['scenarioDefs'],
            type: "relation",
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            defaultValue: (scenarioDef) => {
                return scenarioDef['id'];
            },
            isPublic: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            required: true,
            isPublic: true,
        },
		hideFlowSettingsDuringScenarioApply: {
			name: "Hide Flow Settings During Scenario Apply",
			label: "Flow Settings",
			type: "boolean",
            defaultValue: false,
            isPublic: true,
		},
		ignorePricing: {
			name: "Ignore flow pricing",
			type: "boolean",
            defaultValue: false,
		},
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
